// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ezFastAnimationDuration: 0.25s;
  --ezNormalAnimationDuration: 0.5s;
  --ezSlowAnimationDuration: 1s;
  --ezSimpleAnimationIterationCount: 1;
  --ezInfiniteAnimationItrationCount: infinite;
}

@keyframes ezAnimation_FadeOut {
  0% {
    opacity: 1;
  }
  25% {
    opacity: 0.75;
  }
  50% {
    opacity: 0.5;
  }
  75% {
    opacity: 0.25;
  }
  100% {
    opacity: 0;
  }
}
@keyframes ezAnimation_FadeIn {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 0.25;
  }
  50% {
    opacity: 0.5;
  }
  75% {
    opacity: 0.75;
  }
  100% {
    opacity: 1;
  }
}
@keyframes ezAnimation_FlipX {
  0% {
    transform: rotateX(0deg);
  }
  25% {
    transform: rotateX(90deg);
  }
  50% {
    transform: rotateX(180deg);
  }
  75% {
    transform: rotateX(270deg);
  }
  100% {
    transform: rotateX(360deg);
  }
}
@keyframes ezAnimation_FlipXAndOut {
  0% {
    transform: rotateX(0deg);
    opacity: 1;
  }
  25% {
    transform: rotateX(40deg);
    opacity: 0.75;
  }
  50% {
    transform: rotateX(90deg);
    opacity: 0.5;
  }
  75% {
    transform: rotateX(140deg);
    opacity: 0.25;
  }
  100% {
    transform: rotateX(180deg);
    opacity: 0;
    visibility: hidden;
  }
}
@keyframes ezAnimation_FlipY {
  0% {
    transform: rotateY(0deg);
  }
  25% {
    transform: rotateY(90deg);
  }
  50% {
    transform: rotateY(180deg);
  }
  75% {
    transform: rotateY(270deg);
  }
  100% {
    transform: rotateY(360deg);
  }
}
@keyframes ezAnimation_RotateClockwise {
  0% {
    transform: rotateZ(0deg);
  }
  25% {
    transform: rotateZ(90deg);
  }
  50% {
    transform: rotateZ(180deg);
  }
  75% {
    transform: rotateZ(270deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
.ezFlipX {
  animation-name: ezAnimation_FlipX;
  animation-timing-function: linear;
  animation-direction: normal;
  animation-fill-mode: forwards;
  animation-duration: var(--ezNormalAnimationDuration);
  animation-iteration-count: var(--ezSimpleAnimationIterationCount);
}

.ezFlipUpAndOut {
  animation-name: ezAnimation_FlipXAndOut;
  animation-timing-function: linear;
  animation-direction: normal;
  animation-fill-mode: forwards;
  animation-duration: var(--ezNormalAnimationDuration);
  animation-iteration-count: var(--ezSimpleAnimationIterationCount);
}

.ezFlipY {
  animation-name: ezAnimation_FlipY;
  animation-timing-function: linear;
  animation-direction: normal;
  animation-fill-mode: forwards;
  animation-duration: var(--ezNormalAnimationDuration);
  animation-iteration-count: var(--ezSimpleAnimationIterationCount);
}

.ezRotateClockwise {
  animation-name: ezAnimation_RotateClockwise;
  animation-timing-function: linear;
  animation-direction: normal;
  animation-fill-mode: forwards;
  animation-duration: var(--ezNormalAnimationDuration);
  animation-iteration-count: var(--ezSimpleAnimationIterationCount);
}

.ezFadeOut {
  animation-name: ezAnimation_FadeOut;
  animation-timing-function: ease-out;
  animation-direction: normal;
  animation-fill-mode: forwards;
  animation-iteration-count: var(--ezSimpleAnimationIterationCount);
  animation-duration: var(--ezNormalAnimationDuration);
}

.ezFadeIn {
  animation-name: ezAnimation_FadeIn;
  animation-timing-function: ease-in;
  animation-direction: normal;
  animation-fill-mode: forwards;
  animation-iteration-count: var(--ezSimpleAnimationIterationCount);
  animation-duration: var(--ezNormalAnimationDuration);
}`, "",{"version":3,"sources":["webpack://./ezstyles/ez-animation.css"],"names":[],"mappings":"AAAA;EACI,gCAAA;EACA,iCAAA;EACA,6BAAA;EACA,oCAAA;EACA,4CAAA;AACJ;;AAEA;EACI;IACI,UAAA;EACN;EAEE;IACI,aAAA;EAAN;EAGE;IACI,YAAA;EADN;EAIE;IACI,aAAA;EAFN;EAKE;IACI,UAAA;EAHN;AACF;AAMA;EACI;IACI,UAAA;EAJN;EAOE;IACI,aAAA;EALN;EAQE;IACI,YAAA;EANN;EASE;IACI,aAAA;EAPN;EAUE;IACI,UAAA;EARN;AACF;AAWA;EACI;IACI,wBAAA;EATN;EAYE;IACI,yBAAA;EAVN;EAaE;IACI,0BAAA;EAXN;EAcE;IACI,0BAAA;EAZN;EAeE;IACI,0BAAA;EAbN;AACF;AAgBA;EACI;IACI,wBAAA;IACA,UAAA;EAdN;EAiBE;IACI,yBAAA;IACA,aAAA;EAfN;EAkBE;IACI,yBAAA;IACA,YAAA;EAhBN;EAmBE;IACI,0BAAA;IACA,aAAA;EAjBN;EAoBE;IACI,0BAAA;IACA,UAAA;IACA,kBAAA;EAlBN;AACF;AAqBA;EACI;IACI,wBAAA;EAnBN;EAsBE;IACI,yBAAA;EApBN;EAuBE;IACI,0BAAA;EArBN;EAwBE;IACI,0BAAA;EAtBN;EAyBE;IACI,0BAAA;EAvBN;AACF;AA0BA;EACI;IACI,wBAAA;EAxBN;EA2BE;IACI,yBAAA;EAzBN;EA4BE;IACI,0BAAA;EA1BN;EA6BE;IACI,0BAAA;EA3BN;EA8BE;IACI,0BAAA;EA5BN;AACF;AA+BA;EACI,iCAAA;EACA,iCAAA;EACA,2BAAA;EACA,6BAAA;EACA,oDAAA;EACA,iEAAA;AA7BJ;;AAgCA;EACI,uCAAA;EACA,iCAAA;EACA,2BAAA;EACA,6BAAA;EACA,oDAAA;EACA,iEAAA;AA7BJ;;AAgCA;EACI,iCAAA;EACA,iCAAA;EACA,2BAAA;EACA,6BAAA;EACA,oDAAA;EACA,iEAAA;AA7BJ;;AAgCA;EACI,2CAAA;EACA,iCAAA;EACA,2BAAA;EACA,6BAAA;EACA,oDAAA;EACA,iEAAA;AA7BJ;;AAgCA;EACI,mCAAA;EACA,mCAAA;EACA,2BAAA;EACA,6BAAA;EACA,iEAAA;EACA,oDAAA;AA7BJ;;AAgCA;EACI,kCAAA;EACA,kCAAA;EACA,2BAAA;EACA,6BAAA;EACA,iEAAA;EACA,oDAAA;AA7BJ","sourcesContent":[":root {\r\n    --ezFastAnimationDuration: 0.25s;\r\n    --ezNormalAnimationDuration: 0.5s;\r\n    --ezSlowAnimationDuration: 1s;\r\n    --ezSimpleAnimationIterationCount: 1;\r\n    --ezInfiniteAnimationItrationCount: infinite;\r\n}\r\n\r\n@keyframes ezAnimation_FadeOut {\r\n    0% {\r\n        opacity: 1;\r\n    }\r\n\r\n    25% {\r\n        opacity: 0.75;\r\n    }\r\n\r\n    50% {\r\n        opacity: 0.50;\r\n    }\r\n\r\n    75% {\r\n        opacity: 0.25;\r\n    }\r\n\r\n    100% {        \r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n@keyframes ezAnimation_FadeIn {\r\n    0% {\r\n        opacity: 0;\r\n    }\r\n\r\n    25% {\r\n        opacity: 0.25;\r\n    }\r\n\r\n    50% {\r\n        opacity: 0.50;\r\n    }\r\n\r\n    75% {\r\n        opacity: 0.75;\r\n    }\r\n\r\n    100% {        \r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes ezAnimation_FlipX {\r\n    0% {        \r\n        transform: rotateX(0deg);    \r\n    }\r\n\r\n    25% {\r\n        transform: rotateX(90deg);\r\n    }\r\n\r\n    50% {\r\n        transform: rotateX(180deg);\r\n    }\r\n\r\n    75% {\r\n        transform: rotateX(270deg);\r\n    }\r\n\r\n    100% {\r\n        transform: rotateX(360deg);        \r\n    }\r\n}\r\n\r\n@keyframes ezAnimation_FlipXAndOut {\r\n    0% {        \r\n        transform: rotateX(0deg);\r\n        opacity: 1;\r\n    }    \r\n\r\n    25% {\r\n        transform: rotateX(40deg);\r\n        opacity: 0.75;\r\n    }\r\n\r\n    50% {\r\n        transform: rotateX(90deg);\r\n        opacity: 0.50;\r\n    }\r\n\r\n    75% {\r\n        transform: rotateX(140deg);\r\n        opacity: 0.25;\r\n    }\r\n\r\n    100% {\r\n        transform: rotateX(180deg);\r\n        opacity: 0;    \r\n        visibility: hidden;    \r\n    }\r\n}\r\n\r\n@keyframes ezAnimation_FlipY {\r\n    0% {        \r\n        transform: rotateY(0deg);    \r\n    }\r\n\r\n    25% {\r\n        transform: rotateY(90deg);\r\n    }\r\n\r\n    50% {\r\n        transform: rotateY(180deg);\r\n    }\r\n\r\n    75% {\r\n        transform: rotateY(270deg);\r\n    }\r\n\r\n    100% {\r\n        transform: rotateY(360deg);        \r\n    }\r\n}\r\n\r\n@keyframes ezAnimation_RotateClockwise {\r\n    0% {        \r\n        transform: rotateZ(0deg);    \r\n    }\r\n\r\n    25% {\r\n        transform: rotateZ(90deg);\r\n    }\r\n\r\n    50% {\r\n        transform: rotateZ(180deg);\r\n    }\r\n\r\n    75% {\r\n        transform: rotateZ(270deg);\r\n    }\r\n\r\n    100% {        \r\n        transform: rotateZ(360deg);        \r\n    }\r\n}\r\n\r\n.ezFlipX {\r\n    animation-name: ezAnimation_FlipX;\r\n    animation-timing-function: linear;       \r\n    animation-direction: normal;    \r\n    animation-fill-mode: forwards;\r\n    animation-duration: var(--ezNormalAnimationDuration);\r\n    animation-iteration-count: var(--ezSimpleAnimationIterationCount);    \r\n}\r\n\r\n.ezFlipUpAndOut {\r\n    animation-name: ezAnimation_FlipXAndOut;\r\n    animation-timing-function: linear;       \r\n    animation-direction: normal;    \r\n    animation-fill-mode: forwards;\r\n    animation-duration: var(--ezNormalAnimationDuration);\r\n    animation-iteration-count: var(--ezSimpleAnimationIterationCount);\r\n}\r\n\r\n.ezFlipY {\r\n    animation-name: ezAnimation_FlipY;\r\n    animation-timing-function: linear;\r\n    animation-direction: normal;\r\n    animation-fill-mode: forwards;\r\n    animation-duration: var(--ezNormalAnimationDuration);\r\n    animation-iteration-count: var(--ezSimpleAnimationIterationCount);\r\n}\r\n\r\n.ezRotateClockwise {\r\n    animation-name: ezAnimation_RotateClockwise;\r\n    animation-timing-function: linear;  \r\n    animation-direction: normal;\r\n    animation-fill-mode: forwards;\r\n    animation-duration: var(--ezNormalAnimationDuration);\r\n    animation-iteration-count: var(--ezSimpleAnimationIterationCount);\r\n}\r\n\r\n.ezFadeOut {\r\n    animation-name: ezAnimation_FadeOut;    \r\n    animation-timing-function: ease-out;    \r\n    animation-direction: normal;\r\n    animation-fill-mode: forwards;    \r\n    animation-iteration-count: var(--ezSimpleAnimationIterationCount);\r\n    animation-duration: var(--ezNormalAnimationDuration);\r\n}\r\n\r\n.ezFadeIn {\r\n    animation-name: ezAnimation_FadeIn;    \r\n    animation-timing-function: ease-in;    \r\n    animation-direction: normal;\r\n    animation-fill-mode: forwards;    \r\n    animation-iteration-count: var(--ezSimpleAnimationIterationCount);\r\n    animation-duration: var(--ezNormalAnimationDuration);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
